module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/two-column-layout/two-column-layout.component.scss
// module id = ./libs/chassis-core/src/app/dashboards/components/two-column-layout/two-column-layout.component.scss
// module chunks = main